import * as React from 'react';
import './edit-modal.scss';
import { Modal } from '../../../../../components/modal/modal';
import { updateTransaction } from '../../../../../core/repositories/orders-transactions';
import { Dropdown } from 'components/dropdown/dropdown';
import { Button, buttonType } from 'components/button/button';
import { Enum } from 'core/domain/commons/common';
import { Input } from 'components/input/input';
import { Transaction } from 'core/domain/transaction/transaction';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';

interface Props {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    item: Transaction;
    // فقط بعد از ثبت موفق صدا زده می‌شود. قبلاً یک `onClose` بود که با هر بار
    // بسته شدن مودال (حتی «بازگشت») جدول را دوباره می‌گرفت و در عوض بعد از ثبت
    // موفق، مودال را نمی‌بست.
    onSuccess: () => void;
    transactionStates: Enum[];
}

export const TransactionEditModal: FC<Props> = ({ isOpen, setIsOpen, item, onSuccess, transactionStates }) => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [walletAddress, setWalletAddress] = useState<string>(item.wallet?.walletAddress);
    const [txId, setTxId] = useState<string>(item.txId ?? '');
    const [selectedState, setSelectedState] = useState<Enum>(
        transactionStates.filter((q) => q.title === item.state.title)[0],
    );

    useEffect(() => {
        setWalletAddress(item.wallet?.walletAddress);
        setTxId(item.txId ?? '');
        setSelectedState(transactionStates.filter((q) => q.title === item.state.title)[0]);
    }, [item]);

    return (
        <Modal title="تغییر تراکنش" className="transaction-edit-modal" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="content">
                <div className="row">
                    <label>تغییر وضعیت تراکنش</label>
                    {transactionStates?.length > 0 && (
                        <Dropdown
                            items={transactionStates.filter((item) => item.id > 0)}
                            onChangeHandle={(value) =>
                                setSelectedState(transactionStates.filter((item) => item.id === value)[0])
                            }
                            selectedOption={selectedState}
                        />
                    )}
                </div>
                <div className="row">
                    <label>تغییر آدرس کیف پول</label>
                    <Input
                        className={!!walletAddress ? 'en' : ''}
                        dir={!!walletAddress ? 'ltr' : 'rtl'}
                        placeholder="آدرس کیف پول را وارد کنید"
                        value={walletAddress}
                        onChange={(e) => setWalletAddress(e.target.value)}
                    />
                </div>
                <div className="row">
                    <label>تغییر هش</label>
                    <Input
                        className={!!txId ? 'en' : ''}
                        dir={!!txId ? 'ltr' : 'rtl'}
                        placeholder="TxId را وارد کنید"
                        value={txId}
                        onChange={(e) => setTxId(e.target.value)}
                    />
                </div>

                <div className="buttons">
                    <Button
                        loading={buttonLoading}
                        type={buttonType.info}
                        text="اعمال تغییرات"
                        onClick={async () => {
                            if (!item.id || !selectedState) return;
                            await updateTransaction(
                                setButtonLoading,
                                {
                                    id: item.id,
                                    walletAddress: walletAddress || null,
                                    txId: txId || null,
                                    state: selectedState.id,
                                },
                                () => {
                                    setIsOpen(false);
                                    onSuccess();
                                },
                            );
                        }}
                    />
                    <Button type={buttonType.outlined} text="بازگشت" onClick={() => setIsOpen(false)} />
                </div>
            </div>
        </Modal>
    );
};
